import NextImage from 'next/image';
import { FC } from 'react';

import UserIcon from '@/assets/icons/ic-user.svg';

import { AnyProfile, getProfileAvatar, getProfileFullName } from '@/utils/profileHelpers';

export const ProfileIcon: FC<{ profile: AnyProfile; size: number }> = ({ profile, size }) => {
  const avatarUrl = profile && getProfileAvatar(profile);

  if (!avatarUrl) {
    return <UserIcon />;
  }

  return (
    <NextImage
      width={size}
      height={size}
      src={avatarUrl}
      alt={getProfileFullName(profile)}
      style={{ borderRadius: '50%', width: size, height: size }}
    />
  );
};
